import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { checkoutUrl, offerSummary, trustLine } from '../data/offer';
export function PricingPack() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-154" data-mp="10f0pp1m0nfqs">
      <Reveal className="mx-auto max-w-3xl" data-id="element-155" data-mp="10cnxlvmjnp00">
        <div className="text-center" data-id="element-156" data-mp="15dalnefkekdg">
          <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-157" data-mp="15ed89a5uu0nk">
            💳 Il tuo investimento <span className="text-sage" data-id="element-158" data-mp="1t47kpqm9hn7a">oggi</span>
          </h2>
        </div>
        <div id="collezione-completa" className="mt-10 scroll-mt-4 overflow-hidden rounded-2xl border border-amber/50 bg-surface shadow-elevated" data-id="element-159" data-mp="1y16gsephk484">
          <div className="border-b border-amber/40 bg-amber-pale px-5 py-3 text-center text-sm font-bold text-navy" data-id="element-160" data-mp="1o3jydi8z9uje">
            🧘 Pacchetto completo · Tutto incluso · Senza upsell nascosti · Senza abbonamenti
          </div>
          <div className="p-7 sm:p-10" data-id="element-161" data-mp="cqpuof304aaf">
            <div className="text-center" data-id="element-162" data-mp="hvh7yz9vijch">
              <h3 className="font-serif text-3xl leading-tight text-navy" data-id="element-163" data-mp="hwjw4zfta7op">Sistema delle Costellazioni Familiari™</h3>
              <p className="mt-1 font-serif text-xl italic text-amber" data-id="element-164" data-mp="cxyx33capu1u">La Collezione Completa</p>
              <p className="mt-3 text-xs font-bold uppercase tracking-[0.18em] text-sage" data-id="element-165" data-mp="qxqhpmxbi8ot">6 Tomi + 5 Bonus Premium</p>
            </div>

            <div className="mt-8 grid gap-8 md:grid-cols-2" data-id="element-166" data-mp="mwy3ef9l9dlo">
              <div data-id="element-167" data-mp="10ss4wd8190or">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-168" data-mp="10s9ywovkj83n">Ciò che ricevi</p>
                <ul className="mt-4 space-y-2 text-sm leading-relaxed text-slate" data-id="element-169" data-mp="vtfjzy0q23ot">
                  {offerSummary.map(item => <li key={item} className="flex gap-2" data-id="element-170" data-mp="15kjo22ov044v">
                      <span aria-hidden="true" className="text-amber" data-id="element-171" data-mp="15n630ne2xlx4">
                        ✦
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>
              <div data-id="element-172" data-mp="c8vbf9ouw51t">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-173" data-mp="c9eitwgvrb1l">Ciò che tutto vale</p>
                <p className="mt-4 flex items-baseline justify-between gap-3 border-b border-navy/10 pb-3 text-sm font-bold text-navy" data-id="element-174" data-mp="h87zfxrgri5z">
                  <span data-id="element-175" data-mp="l76xqziowgog">Valore totale reale</span>
                  <span className="line-through" data-id="element-176" data-mp="q0ryv0fkxqrv">94 EUR</span>
                </p>
                <div className="mt-5 rounded-xl bg-amber-pale p-4 text-center" data-id="element-177" data-mp="uzct8j85hg8e">
                  <p className="text-sm font-extrabold uppercase tracking-[0.1em] text-navy" data-id="element-178" data-mp="zxnzyl35fame">Risparmi 75 EUR</p>
                  <p className="mt-1 text-xs font-semibold text-sage" data-id="element-179" data-mp="14whg6l9tlfq9">I 5 bonus sono 100% gratuiti</p>
                </div>
              </div>
            </div>

            <div className="mt-8 border-t border-navy/10 pt-7 text-center" data-id="element-180" data-mp="18wi36uaziz8x">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-181" data-mp="36pyj5bn09seo">Paghi oggi</p>
              <div className="mt-2 font-serif text-6xl leading-none text-navy sm:text-7xl" data-id="element-182" data-mp="3aqhe3ek73el3">
                19<span className="ml-2 align-super text-2xl sm:text-3xl" data-id="element-183" data-mp="33781zdkb11sc">EUR</span>
              </div>
              <p className="mt-2 text-sm text-slate" data-id="element-184" data-mp="2ye6mp4g6r088">Pagamento unico · Senza costi nascosti · Paga in sicurezza</p>
              <div className="mt-6" data-id="element-185" data-mp="2tgwnwy6wpc7q">
                <CTAButton href={checkoutUrl} pulse size="large" data-id="element-186" data-mp="2pfbhnvovnw6i">
                  ⚡ ACCESSO ISTANTANEO
                </CTAButton>
              </div>
              <p className="mt-4 text-xs leading-6 text-slate" data-id="element-187" data-mp="3m4sls687pa63">{trustLine}</p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}